export default "__VITE_ASSET__CUcAPG0s__"